import { ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { ActionControlSemanticColors, getActionControlSemanticColorsWithTheme } from '@1js/acui-common';

import { ribbonStylingConstants } from '../../ribbonStylingConstants';

export interface RibbonTopBarClassNames {
  root: string;
}

export const getRibbonTopBarClassNames = memoizeFunction(
  (theme: ITheme): RibbonTopBarClassNames => {
    const actionControlSemanticColors: ActionControlSemanticColors = getActionControlSemanticColorsWithTheme(theme);
    const styles = {
      root: {
        backgroundColor: actionControlSemanticColors.defaultBackgroundColor,
        whiteSpace: 'nowrap',
        height: ribbonStylingConstants.topBarHeight,
      },
    };
    return mergeStyleSets(styles);
  }
);
